const TaskIndex = () => import('@/views/Dashboard/Task/TaskIndex');
const Tasks = () => import('@/views/Dashboard/Task/View/Grid/TaskGrid');
const TaskDetails = () => import('@/views/Dashboard/Task/Details/TaskDetails');
const TaskCreate = () => import('@/views/Dashboard/Task/Create/TaskCreate');
const TaskEdit = () => import('@/views/Dashboard/Task/Edit/TaskEdit');

export default {
  path: '/tasks',
  component: TaskIndex,
  children: [
    {
      path: '/',
      name: 'task-grid',
      component: Tasks,
      meta: { preserveTableState: true },
    },
    {
      path: ':id',
      name: 'task-show',
      component: TaskDetails,
    },
    {
      path: 'create',
      name: 'task-create',
      component: TaskCreate,
    },
    {
      path: 'edit/:id',
      name: 'task-edit',
      component: TaskEdit,
    },
    {
      path: 'edit/:id/preselected/:memberPreSelectedId',
      name: 'task-editPreSelected',
      component: TaskEdit,
    },
  ],
};
